import { BaseModel } from "sjs-base-model";

export default class ProfiloUtenteModel extends BaseModel {
    public readonly username: string = "";
    public readonly isLogged: boolean = false;
    public readonly isLoginRequired: boolean = false;
    public readonly isCookieAllowed: boolean = false;
    public readonly isMenuFullSize: boolean = true;
    public readonly nome: string = "";
    public readonly cognome: string = "";
    public readonly email: string = "";
    public readonly nomeAzienda: string = "";
    public readonly cdc: string = "";
    public readonly tipoCdc: string = "";
    public readonly descUO: string = "";
    //public readonly codAgency: string = ""; //preso dai cookie

    constructor(data: Partial<ProfiloUtenteModel>) {
        super();

        this.update(data);
    }
}
